module.exports = __webpack_public_path__ + "app-static/img/sign-join.076ac2ca.png";